import { useEffect } from "react";
import { useAppDispatch } from "../../../../../../services/redux/hooks/use-dispatch";
import { useAppSelector } from "../../../../../../services/redux/hooks/use-selector";
import { selectAllModels } from "../../../../../../app/state/modelsSlice/selectors";
import { getModelsAction } from "../../../../../../app/state/modelsSlice/actions";

export const useInitModelsOptions = () => {
  const dispatch = useAppDispatch();
  const models = useAppSelector(selectAllModels);

  useEffect(() => {
    dispatch(getModelsAction());
  }, [models]);

  return {
    models,
  };
};
